import { ReactTyped } from "react-typed";
import { useNavigate } from "react-router-dom";
import CommunityTrips from "./CommunityTrips";
import { TreePalm, Telescope } from "lucide-react";

const NoTripsComponent: React.FC = () => {
  const navigate = useNavigate();

  const handleCreateTrip = () => {
    navigate("/new-trip");
  };

  const handleExplore = () => {
    navigate("/explore");
  };

  return (
    <div className="w-full flex flex-col items-center justify-start space-y-4 mt-6">
      <div className="h-1/2 min-h-1/2 max-h-1/2 flex flex-col w-full items-center justify-center space-y-12 bg-gradient-to-b from-white to-indigo-50 rounded-2xl shadow border border-indigo-100 py-12">
        <div className="flex flex-col items-center justify-center">
          <h1 className="font-normal text-5xl text-neutral-800 leading-tight text-center whitespace-pre-line">
            Turn those{" "}
            <span className="text-indigo-600 min-w-[120px] italic font-semibold">
              <ReactTyped
                strings={[
                  "thoughts",
                  "nights",
                  "chats",
                  "dreams",
                  "plans",
                  "talks",
                  "ideas",
                  "moments",
                  "memories",
                  "maybes",
                  "what ifs",
                ]}
                typeSpeed={90}
                backSpeed={40}
                showCursor
                loop
                backDelay={1000}
              />
            </span>
            {"\n"}
            into trips
          </h1>
        </div>
        <div className="flex flex-col items-center justify-start space-y-4">
          <p className="font-light text-lg bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
            See what we're talking about
          </p>
          <div className="mx-auto justify-center w-full flex flex-row items-center gap-3">
            <button
              onClick={handleCreateTrip}
              className="text-sm px-4 py-2 justify-center h-full w-36 rounded-full bg-indigo-700 hover:bg-indigo-800 transition-all duration-300 text-white flex items-center gap-3"
            >
              <TreePalm size={20} strokeWidth={1.5} />
              <span className="font-light">Create Trip</span>
            </button>
            <button
              onClick={handleExplore}
              className="text-sm px-4 py-2 justify-center h-full w-36 rounded-full bg-white hover:bg-indigo-50 transition-all duration-300 text-indigo-700 flex items-center gap-3 border-2 border-indigo-700"
            >
              <Telescope size={20} strokeWidth={1.5} />
              <span className="font-light">Explore</span>
            </button>
          </div>
        </div>
      </div>
      <CommunityTrips />
    </div>
  );
};

export default NoTripsComponent;
